import React, { FC } from 'react';
import { PollsViewStatuses } from '../../../constans/polls-constants';
import poll_icon from '../../../assets/icons/polls-bar.svg';
import TransparentButton from '../../shared/transparent-button/transparent-button';
import { convertStatusIntoClassName } from '../../../utils/helpers/polls-helper';
import { getMixpanelService } from '../../../utils/services/mixpanel-service-instance';
import { MIXPANEL_EVENT_IDENTIFIERS, MIXPANEL_EVENT_TYPES } from '../../../constans/mixpanel-contants';

interface IProps {
  status: PollsViewStatuses;
  onClick: () => void;
  disabled?: boolean;
}

const OpenCloseButton: FC<IProps> = ({ status, onClick, disabled }) => {
  const pollStatus = status || PollsViewStatuses.NOT_STARTED;
  const disabledClassName = disabled ? 'disabled' : '';
  const mixpanelEventType = pollStatus === PollsViewStatuses.NOT_STARTED
    ? MIXPANEL_EVENT_TYPES.OPENED
    : pollStatus === PollsViewStatuses.IN_PROGRESS
      ? MIXPANEL_EVENT_TYPES.CLOSED
      : MIXPANEL_EVENT_TYPES.OPENED;

  const onClickHandler = (): void => {
    onClick();
    getMixpanelService().track(MIXPANEL_EVENT_IDENTIFIERS.POLLS, mixpanelEventType);
  };

  const getButtonContent = () => {
    switch (status) {
      case PollsViewStatuses.NOT_STARTED:
        return (
          <>
            <img src={poll_icon} alt={`${pollStatus} icon`}/>
            Open Poll
          </>
        );
      case PollsViewStatuses.IN_PROGRESS:
        return (
          <>
            <div className='red-square'/>
            Close Poll
          </>
        );
    }
  };

  return (
    <TransparentButton onClick={onClickHandler} customClasses={`open-close-button ${convertStatusIntoClassName(status)}-button ${disabledClassName}`}>
      {getButtonContent()}
    </TransparentButton>
  );
};

export default OpenCloseButton;
